export default __webpack_public_path__ + "static/Graphik-Regular-Cy-Web-0b89b8287a29f710e110d0c539abfcb0.woff2";